import defaultSettings from "@/settings";
// import { getConfigKey } from "@/api/system/config";
import { set16ToRgb } from "@/utils/ruoyi";


const {
  sideTheme,
  showSettings,
  topNav,
  tagsView,
  fixedHeader,
  sidebarLogo,
  dynamicTitle
} = defaultSettings;

const storageSetting = JSON.parse(localStorage.getItem("layoutQiye-setting")) || "";
const state = {
  title: "",
  theme: '',
  sideTheme: storageSetting.sideTheme || sideTheme,
  showSettings: showSettings,
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  tagsView:
    storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  fixedHeader:
    storageSetting.fixedHeader === undefined
      ? fixedHeader
      : storageSetting.fixedHeader,
  sidebarLogo:
    storageSetting.sidebarLogo === undefined
      ? sidebarLogo
      : storageSetting.sidebarLogo,
  dynamicTitle:
    storageSetting.dynamicTitle === undefined
      ? dynamicTitle
      : storageSetting.dynamicTitle
};
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key))
    {
      state[key] = value;
    }
  },
  SET_THEME: (state, theme) => {
    state.theme = theme;
  },
};

const actions = {
  // 修改布局设置
  changeSetting ({ commit }, data) {
    commit("CHANGE_SETTING", data);
  },
  // 设置网页标题
  setTitle ({ commit }, title) {
    state.title = title;
  },
  // 获取主要颜色
  // ThemeColor({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getConfigKey("sys.index.color")
  //       .then((res) => {
  //         commit("SET_THEME", res.msg);
  //         document.documentElement.style.setProperty('--color-primary',res.msg)
  //         document.documentElement.style.setProperty('--color-peiprimary', set16ToRgb(res.msg))

  //         localStorage.setItem(
  //           "layout-setting",
  //           `{
  //               "theme":"${state.theme}"
  //             }`
  //         );
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js